import commonFun from "@/assets/js/yioks";
import {getUserBlackRecently} from "@/api/system_manager/api";
const { idCard_number } = commonFun;
export default {
    data(){
        return{
            formRules:{
                name:[
                    {required: true, message: '请输入姓名', trigger: 'blur'},
                ],
                mobile_phone:[
                    {required: true,
                        validator: (rule, value, callback) => {
                        if (value){
                            this.$yioks.phone(value) ? callback() : callback(new Error('请输入正确的联系电话'));
                        } else{
                            callback(new Error('请输入手机号'));
                        }
                        },
                        trigger: "blur",}
                ],
                id_number:[
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                          if(value){
                            getUserBlackRecently(value).then(({data:{status, result}}) => {
                              if(Number(status) === 0){
                                  if(result.end_date) {
                                    this.$set(this.BlackList, 'start_date', result.end_date)
                                  }else{
                                    this.BlackList.start_date=this.$yioks.time(new Date().getTime(),false)
                                  }
                              }
                            })
                            callback();
                            }else{
                                callback(new Error('请填写身份有效证件号'))
                            }

                        },
                        trigger: "blur"
                    }
                ],
                start_date:[
                    {required: true, message: '请选择封禁开始时间', trigger: 'change'},
                ],
                end_date:[
                    {required: false, message: '请选择封禁结束时间', trigger: 'change'},
                ],
                type:[
                    {required: true, message: '请选择惩罚类型', trigger: 'change'},
                ],
              behavior:[
                {required: true, message: '请选择处罚结果', trigger: 'change'},
              ],
              basis:[
                {required: true, message: '请选择处罚依据', trigger: 'change'},
              ],
              punish_basis:[
                {required: true, message: '请选择处罚依据', trigger: 'change'},
              ],
              punish_suggest:[
                {required: true, message: '请选择处罚建议', trigger: 'change'},
              ],
                remark:[
                    {required: true, message: '请填写说明', trigger: 'blur'},
                ],
              id_number_punish:[
                {
                  required: true,
                  validator: (rule, value, callback) => {
                    if(value){
                      callback();
                    }else{
                      callback(new Error('请填写身份有效证件号'))
                    }
        
                  },
                  trigger: "blur"
                }
              ],
            }
        }
    }
}
